// @flow
import * as React from "react";

import { Typography } from "antd";

function AuthBrandLogo(): React.Node {
  return (
    <div className="AuthLayout__brandLogo">
      <svg
        className="AuthLayout__brandIcon"
        width="28"
        height="28"
        viewBox="0 0 140 133"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true">
        <path
          clipRule="evenodd"
          d="M41.013 63.333c-1.134 0-2.15-.633-2.698-1.623a3.412 3.412 0 0 1 0-3.245L69.6 1.623C70.148.593 71.204 0 72.299 0s2.151.633 2.699 1.623l31.286 56.842a3.41 3.41 0 0 1 0 3.245c-.587.99-1.603 1.623-2.698 1.623zM141.107 133H78.535c-1.134 0-2.15-.633-2.699-1.623a3.413 3.413 0 0 1 0-3.246l31.287-56.842c.547-1.029 1.603-1.622 2.698-1.622s2.151.633 2.699 1.623l31.286 56.841c.547.99.547 2.256 0 3.246-.587.99-1.604 1.623-2.699 1.623zM3.49 133h62.573c1.095 0 2.112-.633 2.698-1.623a3.413 3.413 0 0 0 0-3.246L37.475 71.289c-.547-.99-1.603-1.622-2.698-1.622s-2.151.593-2.699 1.623L.792 128.13a3.413 3.413 0 0 0 0 3.246c.547.99 1.564 1.623 2.698 1.623z"
          fill="#1294f2"
          fillRule="evenodd"
        />
      </svg>
      <Typography.Title level={4} className="AuthLayout__brandName">
        VORTEX
      </Typography.Title>
    </div>
  );
}

export default AuthBrandLogo;
